module.exports = __webpack_public_path__ + "img/hskz.83530b8c.png";